import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import {styleForHeader} from '../../style.js';

export const GridColumns = [
    { field: 'id', hide: true},
    { field: 'userId', hide:true},
    { field: 'user', width: 300, headerAlign:'left', align:'left', text:'İsim Soyisim', type:'singleSelect',
        renderHeader: () => styleForHeader('İsim Soyisim'),
        renderCell: (params) => (<div>{params.value.fullName}</div>),
        dataList:[],
        keyField:'id',valueField:'fullName' 
    },
    { field: 'telephoneNumber', width: 232, headerAlign:'left', align:'left', type: 'phone', text:'Telefon',
        renderHeader: () => styleForHeader('Telefon')
    },     
    { field: 'emailAddress', width: 440, headerAlign:'left', align:'left', text:'E-posta',
        renderHeader: () => styleForHeader('E-posta')
    },    
    { field: 'useThisInfo', width: 140, headerAlign:'center', align:'center', type: 'checkbox', text:'Bildirim',
        renderHeader: () => styleForHeader('Bildirim'),
        renderCell: (params) => styleForCheckbox(params.value)
    }
];

export const styleForCheckbox = (value) => {
    return (
        <Checkbox checked={value} size="large" sx={{
            color: '#28a5ad',
            '&.Mui-checked': {
              color: '#28a5ad',
            }
          }} />
    )         
}